import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {ParametrePersonnalisationComponent} from "./parametre-personnalisation.component";
import {PersonnalisationLogoComponent} from "@components/admin/parametre/personnalisation/personnalisation-logo/personnalisation-logo.component";
import {ParametrePersonnalisationService} from "./parametre-personnalisation.service";
import {DocumentModule} from "@components/document/document.module";
import {BoiteLienComponent} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien.component";
import {BoiteLienDialogComponent} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien-dialog/boite-lien-dialog.component";
import {BoiteLienItemComponent} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien-item/boite-lien-item.component";
import {BoiteLienService} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien.service";

export const parametrePersonnalisationRoutes : Routes = [
    {
        path: 'Logo',
        component: PersonnalisationLogoComponent,
        canActivate: [AdminGuardProvider]
    },
    {
        path: 'BoiteLien',
        component: BoiteLienComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Logo'
    }, {
        path: '**',
        redirectTo: 'Logo'
    }
];

@NgModule({
    imports: [ShareModule, DocumentModule],
    declarations: [
        ParametrePersonnalisationComponent,
        PersonnalisationLogoComponent,
        BoiteLienComponent,
        BoiteLienDialogComponent,
        BoiteLienItemComponent,
    ],
    exports: [
        ParametrePersonnalisationComponent,
        PersonnalisationLogoComponent,
        BoiteLienComponent,
    ],
    providers: [
        ParametrePersonnalisationService,
        BoiteLienService,
    ]
})
export class ParametrePersonnalisationModule {}
